export enum EnumTipoPropagandaDestaque {
    NaoInformado = 0,
    Alto = 3,
    Medio = 2,
    Baixo = 1
}